export default "__VITE_ASSET__CPHduzMB__"